import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CommonPagesModule } from '@eceos/common-pages';
import { DefaultSharedModule } from '@eceos/default-shared';

import { LayoutModule } from './layout/layout.module';

@NgModule({
  imports: [CommonModule, DefaultSharedModule, CommonPagesModule, LayoutModule],
  exports: [DefaultSharedModule, CommonPagesModule, LayoutModule]
})
export class SharedModule {}
